import React, { Suspense } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import ErrorBoundary from '../errorBoundary';
import SignalrProvider from '../signalR';
import OfflineNotification from '../offlineNotification';
import BusyIndicator from '../busyIndicator';
import AuthenticationProvider, { Roles } from '../authentiction';
import ModalProvider, { ModalRoot } from '../modals';
import AdminShell, { AdminLoginPage } from '../admin';
import ReceptionRoutes, { ReceptionLoginPage } from '../reception';
import VisitorRoutes, { VisitorLoginPage } from '../visitor';
import LandingPage from '../landingPage';
import SignInAsGuest from '../visitor/signInAsGuest';
import PrivateRoute from '../routes/privateRoute';
import NotFoundPage from '../routes/notFound';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const baseUrl =
  document.getElementsByTagName('base')[0].getAttribute('href') || '/';

toast.configure({ autoClose: 10000 });

//const Shell = lazy(() => import(/* webpackChunkName: "Shell" */ '../admin').);

const App: React.FC = () => (
  <Router basename={baseUrl}>
    <ErrorBoundary>
      <SignalrProvider url="/notificationsHub">
        <OfflineNotification />
        <AuthenticationProvider>
          <ModalProvider>
            <ModalRoot />
            <Suspense
              fallback={<BusyIndicator text="Loading assets" fullScreen />}
            >
              <Switch>
                <Route path="/admin/login" component={AdminLoginPage} />
                <Route path="/reception/login" component={ReceptionLoginPage} />
                <Route path="/visitor/login" component={VisitorLoginPage} />
                <Route
                  path={'/visitor/site/:pin/signIn'}
                  component={SignInAsGuest}
                />
                <PrivateRoute
                  path="/admin"
                  roles={[Roles.Admin]}
                  component={AdminShell}
                />
                <PrivateRoute
                  path="/reception"
                  roles={[Roles.Reception]}
                  component={ReceptionRoutes}
                />
                <PrivateRoute
                  path="/visitor"
                  roles={[Roles.Visitor, Roles.Guest]}
                  component={VisitorRoutes}
                />
                <Route exact path="/" component={LandingPage} />
                <Route component={NotFoundPage} />
              </Switch>
            </Suspense>
          </ModalProvider>
        </AuthenticationProvider>
      </SignalrProvider>
    </ErrorBoundary>
  </Router>
);

export default App;
